/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

function initSliders() {
  const blocks = document.querySelectorAll('.karting-pinto-slider');

  blocks.forEach((block) => {
    const textSliderEl = block.querySelector('.kp-swiper');
    const imageSliderEl = block.querySelector('.kp-swiper-images');

    if (!textSliderEl || !imageSliderEl) return;

    const textSwiper = new Swiper(textSliderEl, {
      slidesPerView: 1,
      loop: false,
      spaceBetween: 20,
      navigation: {
        nextEl: block.querySelector('.karting-pinto-slider__btnnext'),
        prevEl: block.querySelector('.karting-pinto-slider__btnprev'),
      },
    });

    const imageSwiper = new Swiper(imageSliderEl, {
      slidesPerView: 1,
      loop: false,
      allowTouchMove: true,
      pagination: {
        el: block.querySelector('.karting-pinto-slider__pagination'),
        clickable: true,
      },
    });

    // 🔥 Sincronización
    textSwiper.controller.control = imageSwiper;
    imageSwiper.controller.control = textSwiper;
  });
}

document.addEventListener('DOMContentLoaded', initSliders);
